import { GET } from "../../../API/get";

const fetchApiData = async (url) => {
    const response = await GET(url);
    return response?.status === "Success" ? response : null;
}

export const fetchPersonalDocumentHistory = ({ftm_id, document_type_id}) => fetchApiData(`ftm/personal/document/history/${ftm_id}/${document_type_id}`);
export const fetchCertificateHistory = ({ftm_id, document_type_id}) => fetchApiData(`ftm/certificate/history/${ftm_id}/${document_type_id}`);